import { render, staticRenderFns } from "./InvoicingXippPlatformTable.vue?vue&type=template&id=a38d8198&"
import script from "./InvoicingXippPlatformTable.vue?vue&type=script&lang=js&"
export * from "./InvoicingXippPlatformTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoicingXippPlatformTable.vue?vue&type=style&index=0&id=a38d8198&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports